<template>
  <div class="login-container">
    <img :src="loginBj" class="login-bg" />
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
      auto-complete="on"
      label-position="right"
    >
      <img :src="logoF" style="width:108px;height:38px;" />
      <div class="title">{{ title }}账户登录</div>
      <div class="title-des">
        您可以直接输入您的{{ title }}会员账号和密码登录
      </div>
      <el-form-item prop="account">
        <span class="svg-container svg-container_login">
          <svg-icon icon-class="user" />
        </span>
        <el-input
          v-model="loginForm.username"
          name="account"
          type="text"
          auto-complete="on"
          placeholder="账号"
        />
      </el-form-item>
      <el-form-item prop="password">
        <span class="svg-container">
          <svg-icon icon-class="loginPw" />
        </span>
        <el-input
          :type="pwdType"
          v-model="loginForm.password"
          name="password"
          auto-complete="on"
          placeholder="密码"
          @keyup.enter.native="handleLogin"
        />
        <span class="show-pwd" @click="showPwd">
          <svg-icon icon-class="eye" />
        </span>
      </el-form-item>

      <!-- <el-form-item prop="img_code" style="margin-bottom: 10px">
        <span class="svg-container">
          <svg-icon icon-class="loginCode" />
        </span>
        <el-input
          v-model="loginForm.captchaCode"
          name="img_code"
          auto-complete="on"
          placeholder="验证码"
        />
        <span class="show-pwd show-code" @click="getCodeImg">
          <el-image :src="imgCodePath" />
        </span>
      </el-form-item> -->
      <!-- <div class="password-warp">
        <div class="forgot-password">忘记密码？立即找回</div>
      </div> -->
      <div @keyup.enter="handleLogin">
        <el-button
          :loading="loading"
          type="primary"
          style="width:100%;"
          @click.native.prevent="handleLogin"
        >
          登录
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { getVerifyCode } from "@/api/common";
import { Message } from "element-ui";
import defaultSettings from "@/settings";

export default {
  name: "Login",
  data() {
    const validateName = (rule, value, callback) => {
      if (value.length <= 0) {
        callback(new Error("账号不能为空"));
      } else {
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("密码不能小于6位"));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        username: "",
        password: "",
        captchaKey: new Date().valueOf(),
        captchaCode: "",
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", validator: validateName },
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePass },
        ],
      },
      loading: false,
      pwdType: "password",
      imgCodePath: "", // 验证码得路径
      // isRememberPw: false // 是否记住密码
      title: defaultSettings.title,
      logoF: defaultSettings.logoF,
      loginBj: defaultSettings.loginBj,
    };
  },
  mounted() {
    this.getCodeImg();
    // const loginInfo = getLogionUserInfo();
    // if (loginInfo && Object.keys(loginInfo).length !== 0) {
    //   this.isRememberPw = true;
    //   this.loginForm.username = loginInfo.username;
    //   this.loginForm.password = loginInfo.password;
    // }
    window.onBridgeShowApp = (item) => {
      console.log("---qxx2--", item);
      this.$store.dispatch("appLogin", item).then((res) => {
        this.$router.push({ path: "/" });
      });
    };
  },
  methods: {
    showPwd() {
      if (this.pwdType === "password") {
        this.pwdType = "";
      } else {
        this.pwdType = "password";
      }
    },
    handleLogin() {
      // const isRememberPw = this.isRememberPw; // 记住密码
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          // const loginForm = this.loginForm;
          this.$store
            .dispatch("Login", this.loginForm)
            .then((res) => {
              console.log("getCodeImg--记住密码--", res);
              if (res === -2) {
                this.getCodeImg();
              } else {
                // let userInfo = {};
                // // 己住密码
                // if (isRememberPw) {
                //   userInfo = {
                //     username: loginForm.username,
                //     password: loginForm.password
                //   };
                // }
                // // 设置记住密码
                // setLogionUserInfo(userInfo);
                this.$router.push({ path: "/" });
              }
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /**
     * 获取验证码的图片
     */
    getCodeImg() {
      // this.loginForm.captchaKey = new Date().valueOf();
      // getVerifyCode(this.loginForm.captchaKey)
      //   .then(resp => {
      //     this.imgCodePath = resp.data;
      //   })
      //   .catch(error => {
      //     Message({
      //       message: "获取验证码异常",
      //       type: "error",
      //       duration: 5 * 1000
      //     });
      //   });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/index";

$fontColor: #000000ff; // 主题字颜色
$inputBgColor: #fef2ecff; // 登录页面-input-背景色
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;
.login-container {
  position: relative;
  height: calc(100vh - 4px);
  width: 100%;

  .login-bg {
    width: 100%;
    height: 100%;
    display: block;
  }

  .login-form {
    position: absolute;
    left: 16%;
    top: 16%;
    width: 390px;
  }
  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;
    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }
  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
    &_login {
      font-size: 20px;
    }
  }
  .title {
    font-size: 28px;
    font-weight: 400;
    color: $fontColor;
    margin: 6px auto auto auto;
  }
  .title-des {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
    margin: 10px auto 84px auto;
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
  .show-code {
    .el-image {
      height: 38px;
    }
  }
  .password-warp {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
    font-size: 12px;
  }
  .forgot-password {
    cursor: pointer;
  }
  .forgot-password:hover {
    color: $Theme-color;
    text-decoration: underline;
  }
  ::v-deep .el-button--primary {
    background-color: $Theme-color;
    border-color: $Theme-color;
    border-radius: 30px;
  }
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
    }
  }
  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: $inputBgColor;
    border-radius: 5px;
    color: #454545;
  }
  ::v-deep .el-input__inner {
    background-color: $inputBgColor;
    border-color: $inputBgColor;
  }
  ::v-deep .el-form-item.is-error .el-input__inner,
  .el-form-item.is-error .el-input__inner:focus,
  .el-form-item.is-error .el-textarea__inner,
  .el-form-item.is-error .el-textarea__inner:focus {
    border-color: $inputBgColor;
  }
  .keep-login .el-checkbox {
    color: #fff;
    opacity: 0.8;
  }
  ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
    color: $Theme-color;
  }
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: $Theme-color;
    border-color: $Theme-color;
  }
  ::v-deep .el-checkbox__inner:hover {
    border-color: $Theme-color;
  }
}

/* 移动端适配 - 隐藏背景图片 */
@media screen and (max-width: 768px) {
  .login-container {
    .login-bg {
      display: none;
    }

    .login-form {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 90%;
      max-width: 350px;
    }

    .title {
      font-size: 24px;
      margin: 10px auto;
    }

    .title-des {
      font-size: 13px;
      margin: 10px auto 40px auto;
    }

    .svg-container {
      padding: 6px 3px 6px 12px;
      &_login {
        font-size: 18px;
      }
    }

    .show-pwd {
      right: 8px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 14px;
    }

    .password-warp {
      margin-bottom: 30px;
      font-size: 11px;
    }

    .el-input {
      height: 45px;
      width: calc(100% - 45px);
      input {
        height: 45px;
        font-size: 14px;
      }
    }

    ::v-deep .el-button--primary {
      height: 45px;
      font-size: 15px;
    }
  }
}

/* 小屏手机适配 */
@media screen and (max-width: 480px) {
  .login-container {
    .login-form {
      width: 92%;
      max-width: 300px;
      padding: 0 5px;
    }

    .title {
      font-size: 22px;
    }

    .title-des {
      font-size: 12px;
      margin: 8px auto 30px auto;
    }

    .svg-container {
      padding: 6px 2px 6px 10px;
      width: 28px;
      &_login {
        font-size: 16px;
      }
    }

    .show-pwd {
      right: 6px;
      font-size: 13px;
    }

    .password-warp {
      margin-bottom: 25px;
      font-size: 10px;
    }

    .el-input {
      height: 42px;
      width: calc(100% - 40px);
      input {
        height: 42px;
        font-size: 13px;
      }
    }

    ::v-deep .el-button--primary {
      height: 42px;
      font-size: 14px;
    }
  }
}
</style>
